import { PropTypes } from 'prop-types';
import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import ContentTabs from '../../../core/components/ContentTabs';

class ClaimsViews extends Component {
  static propTypes = {
    children: PropTypes.node,
    match: PropTypes.shape({
      params: PropTypes.shape({
        site: PropTypes.string.isRequired,
      }).isRequired,
    }).isRequired,
  };

  render() {
    return (
      <div className="container-fluid">
        <section className="page-main-content">{this.props.children}</section>
      </div>
    );
  }
}

export default withRouter(ClaimsViews);
